<template>
  <!--
    The guest chip in the hub's top bar: who is looking at this house while it
    is not theirs (card `t_803e86a4`). It sits INSIDE the one top-bar row —
    nothing here adds a band to that bar — and it is the first thing that gives
    way at a narrow width (`max-w` + `truncate`), because the page's own title
    is not the only item allowed to shrink on a phone.
  -->
  <span
    v-if="isGuest"
    data-demo-guest-pill
    class="inline-flex max-w-[7.5rem] flex-shrink-0 items-center gap-1 rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600 dark:border-gray-600 dark:bg-gray-700/60 dark:text-gray-300 md:max-w-[12rem]"
    :title="label">
    <span class="material-symbols-outlined text-sm leading-none">person</span>
    <span class="truncate">{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDemoGuest } from '../../composables/useDemoGuest';

const { t } = useI18n();
const { isGuest, guestName } = useDemoGuest();

/**
 * "Guest · Maja", or bare "Guest" while the identity has not loaded yet (the
 * welcome page's flag paints the chip before `/users/me` answers — see
 * `useDemoGuest`). The full name rides on `title` so a truncated one is still
 * readable where the pointer is.
 */
const label = computed(() =>
  guestName.value ? t('views.demoGuest.pillNamed', { name: guestName.value }) : t('views.demoGuest.pill'),
);
</script>
